var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 14,
    fill: "#FF8C2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.096 30L16.68 22.32V20.808H17.784C18.456 20.808 19.04 20.728 19.536 20.568C20.032 20.408 20.432 20.16 20.736 19.824C21.056 19.472 21.264 19.04 21.36 18.528H16.68V16.848H21.336C21.24 16.352 21.056 15.936 20.784 15.6C20.512 15.264 20.152 15.008 19.704 14.832C19.256 14.64 18.712 14.544 18.072 14.544H16.68V12.864H27.168V14.544H23.112C23.432 14.848 23.688 15.192 23.88 15.576C24.088 15.944 24.224 16.368 24.288 16.848H27.168V18.528H24.336C24.192 19.696 23.736 20.616 22.968 21.288C22.216 21.944 21.232 22.376 20.016 22.584L24.672 30H21.096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/paymentIcon.340bc4ce99fc495f98a0e080c077c105.svg";
export { ForwardRef as ReactComponent };